// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__34fW6","colMaxWidth":"Table_colMaxWidth__1sAcJ"};